import React, { useState, useEffect } from 'react';
import BookingServices from '../../services/BookingServices';
function SelectOrderStatus({ data,page, onSuccess }) {
    
  const [selectedSequence, setSelectedSequence] = useState(data.status || "Pending");

  useEffect(() => {
    setSelectedSequence(data.status || "Pending");
  }, [data]);

  const handleSequenceChange = async (event) => {
    const newSequence = event.target.value;
    setSelectedSequence(newSequence);
    try {
      await BookingServices.updateBooking(data._id, {
        status: newSequence,
      });
      onSuccess();
    } catch (error) {
      console.error('Failed to update Order Status', error);
      
    }
    
  };

  return (
    <select
      className=""
      value={selectedSequence}
      onChange={handleSequenceChange}
    >
      
     
        <option key="Pending" value="Pending">
        Pending
        </option>
        {/* <option key="Ongoing" value="Ongoing">
        Ongoing
        </option>
        <option key="Confirmed" value="Confirmed">
        Confirmed
        </option>
        <option key="Completed" value="Completed">
        Completed
        </option>
        <option key="OutOfDelivery" value="OutOfDelivery">
        OutOfDelivery
        </option> */}
        <option key="Cancelled" value="Cancelled">
        Cancelled
        </option>
         <option key="Completed" value="Completed">
        Completed
        </option>
      
    </select>
  );
}

export default SelectOrderStatus;